exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-inscrito-newsletter-js": () => import("./../../../src/pages/inscrito-newsletter.js" /* webpackChunkName: "component---src-pages-inscrito-newsletter-js" */),
  "component---src-templates-home-js": () => import("./../../../src/templates/home.js" /* webpackChunkName: "component---src-templates-home-js" */),
  "component---src-templates-landing-page-pattern-js": () => import("./../../../src/templates/landingPagePattern.js" /* webpackChunkName: "component---src-templates-landing-page-pattern-js" */)
}

